export { default } from "./EditableLabeledText";
